<style lang="scss">
    @import '~@/assets/css/var';
    .table-title {
        margin-bottom: $intervalWidth;

        &__left {
            float: left;
            font-size:12px;
            line-height: normal;
        }

        &__right {
            float: right;
        }
        &__normal {
            display: inline-block;
            padding-right: $intervalWidth;
            &-type {
                width: 100px;
                .el-input__inner {
                    border-right: 0;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-color: #DCDFE6 !important;
                }
            }
            &-value {
                width: 240px !important;
                input, &.el-input__inner {
                    border-left: 0;
                    border-radius: 0;
                    border-color: #DCDFE6 !important;
                }
                &.el-range-editor.el-input__inner {
                    padding: 2px 10px;
                }
            }
        }
    }


    .draggable {
        width: 300px;
        margin: 10px auto;
        &-item {
            position: relative;
            border: 1px solid $border;
            margin-bottom: -1px;
            padding: 10px;
            line-height: 20px;
            cursor: move;
            .el-switch {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
            }

            &:first-child {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }
            &:last-child {
                border-bottom-right-radius: 4px;
                border-bottom-left-radius: 4px;
            }
        }
        .sortable-ghost {
            opacity: .5;
        }
    }
    .advance {
        .el-button--text {
            font-size: 16px;
        }
        .el-form-item {
            margin: 0;
        }
        &-field {
            width: 150px;
            margin: 0 10px;
        }
        &-operate {
            width: 150px;
            margin-right: 10px;
        }
        &-value {
            .el-form-item__content > * {
                width: 220px;
            }
        }
    }
    .dropdown-size {
        .el-dropdown-menu__item {
            &.active {
                color: $main;
                i {
                    opacity: 1;
                }
            }
            &.show {
                i {
                    opacity: 1;
                }
            }
            i {
                opacity: 0;
            }
        }
    }
    .my-table-block {
        flex: 1;

        .expand {
            padding-left: 42px;
            padding-right: 50px;
        }

        .el-table__header {
            th {
                background: #f5f7fa;
            }
        }

        .el-table__body-wrapper {
            min-height: 150px;
            .el-link {
                font-size: 12px;
            }
        }
        .caret-wrapper {
            height: 21px;
            .ascending {
                top: 0 !important;
            }
            .descending {
                bottom: 0 !important;
            }
        }


        .el-pagination {
            padding: 10px 0 0;
            text-align: right;
            .el-select .el-input {
                margin: 0;
            }
            .el-dropdown {
                i {
                    font-size: 28px;
                }
            }
        }
    }

    .story{border:1px solid #cecece;padding:0 15px 3px;position:relative;}
    .story_t{font-size:14px;color:rgba(0,0,0,1);padding-top:5px;padding-bottom:10px;color: #555;}
    .story_t i{
        padding-right: 5px;}
    .story_t .assist {
        color: #999;
        font-size: 12px;
        padding-left: 5px;
    }
    /*.story_m{color:rgba(110,110,110,1);line-height:21px;word-break:break-all;word-wrap:break-word;overflow:hidden;font-size:15px;padding:2px 0;}*/
    .story_time{color:rgba(154,154,154,1);padding:2px 0;}
    .story_hf{background:rgb(245,245,245);font-size:1.2em;border:1px solid rgba(204,204,204,0.2);border-radius:2px;color:rgba(110,110,110,1);padding:4px;margin-bottom:5px;}
    .opbtn{position:absolute;top: 0;right: 0;}

    .my-table-comment-title {
        padding-bottom:20px;
        font-weight:bold;
        padding-top:10px;
        margin-bottom:10px;
    }

    .my-table-comment-input {
        padding-bottom:20px;
    }

    .opbtn-com {
        float:left;
        padding-right: 14px;
    }

    .opbtn-read {
        float: right;
        padding-right:8px;
    }

    .my-drawer-title {
        .el-drawer {
            transition: width .15s ease-in-out;
        }

        .el-drawer__header {
            padding: 10px;
            margin-bottom: 15px;
            font-size: 12px;
            background: #f2f2f2;

            span {
                font-size: 12px;
                float: right;
            }

            i {
                padding-left: 10px;
                cursor: pointer;
            }

            .el-icon-full-screen {
                &:hover {
                    color: $main;
                }
            }

            .el-icon-close {
                &:hover {
                    color: $red;
                }
            }
        }
        .el-drawer__body {
            padding: 0 15px 15px;
            overflow: auto;
        }
    }

</style>

<template>

    <div class="my-table-comment flex flex-column" style="height: 100%;">
        <div class="my-table-comment-input">
            <div class="my-table-comment-title">  <i class=" el-icon-collection-tag" style="color:blue;padding-right:5px;"></i>发布评论</div>

            <el-input clearable placeholder="请输入评论内容" type="input" v-model="comment" >
                <template slot="prepend" v-if="atName">{{atName}} <i  class="el-icon-circle-close" @click="clearModel"></i></template>
                <el-button slot="append" type="primary" @click="saveComment()"  >发布</el-button>
            </el-input>
        </div>



        <div class="my-table-block flex flex-column" style="height: 581px; "  v-if="loaded" >

            <div class="my-table-comment-title" >  <i class=" el-icon-collection-tag" style="color:blue;padding-right:5px;"></i>评论记录</div>

            <el-table ref="commTable" :data="data" class="flex-item" :size="size" stripe :border="hasLine" :height="250" :show-header=false resizable=true
                      @sort-change="sort" :highlight-current-row="isShowSingleChecked" :lazy="false"
                      @row-dblclick="handleRowDbClickChange" @row-click="handleRowClickChange" @select="handleSelect" >

                <!--region 自定义列-->
                <el-table-column fixed prop="item" :is-hidden="false">
                    <template slot-scope="props">
                        <div class="story">
                            <div class="opbtn">
                                <div class="opbtn-com" @click="triggerComm(props.row)"  style="font-family: Microsoft YaHei;" ><i class="el-icon-chat-dot-square" style="padding-right:2px;"></i></div>
                                <div class="opbtn-read" @click="triggerDel(props.row)" style="font-family: Microsoft YaHei;"><i class="el-icon-close" style="padding-right:2px;"></i></div>
                            </div>
                            <p class="story_t"><i class="el-icon-user-solid"></i>{{props.row['userName']}}
                                <template v-if="props.row['childUserName']">
                                    回复 &nbsp;{{props.row['childUserName']}}
                                </template>
                                <span class="assist">{{props.row['ts']}}</span>

                            </p>
                            <p class="story_m">{{props.row['comment']}}</p>
<!--                            <p class="story_hf">@剑花烟雨:的是相对无言眼波如流的默契的是相对无言眼波如流的默契的是相对无言眼波如流的默契的是相对无言眼波如流的默契的是相对无言眼波如流的默契的是相对无言眼波如流的默契</p>-->
                        </div>

                    </template>
                </el-table-column>

            </el-table>

            <el-pagination v-if="!hidePage" :current-page.sync="pageParam.current" :page-sizes="[5, 10, 20]"
                           :page-size="pageParam.size" :layout="layout" :total="pageParam.total"
                           @size-change="handleSizeChange" @current-change="handleCurrentChange">
                <el-dropdown size="medium" :hide-on-click="false" trigger="click" @command="tableSizeChange" v-show="!single">
                    <el-button><i class="el-icon-menu"></i></el-button>
                    <el-dropdown-menu class="dropdown-size" size="medium">
                        <el-dropdown-item :class="{active : size === item.key}" v-for="item in variable.tableSize" :key="item.key"
                                          icon="el-icon-check" :command="item.key">{{item.value}}</el-dropdown-item>
                        <el-dropdown-item divided>
                            <el-switch v-model="hasLine" active-text="显示竖向分割线" @change="tableLineChange"></el-switch>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-pagination>


        </div>

    </div>

</template>

<script>
    import help from '@/util/help';
    import variable from '@/util/variable';

    export default {
        props: {
            // 表格里的操作列
            operate: {
                type: Array,
                default: () => {
                    return []
                }
            },
            headId: {
                type: String,
            },
            comApi: {

            },
            // 列的表头
            cols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            stripe: {
                type: String,
            },
            operateWidth: {},
            // 表数据
            data: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 页面名称
            pageName:{
                type: String,
            },
            // 表格唯一表示
            name: {},
            // 隐藏操作行
            hideOperate: {
                type: Boolean,
                default: false
            },
            // 表高度
            height: {
                type: Number,
                default: 250,
            },
            // 是否显示el-table的单选
            isShowSingleChecked: {
                type: Boolean,
                default: false
            },
            // 是否隐藏序列
            hideSerial: {
                type: Boolean,
                default: false
            },
            // 是否隐藏分页
            hidePage: {
                type: Boolean,
                default: false
            },
            // 是否隐藏多选列
            hideMultiple: {
                type: Boolean,
                default: false
            },
            // 是否简单类型
            single: {
                type: Boolean,
                default: false
            },
            // 页码的相关参数
            pageParam: {
                type: Object,
                default: () => {
                    return {
                        index: 1,
                        size: 5,
                        total: 0
                    }
                }
            },
            layout: {
                default: 'prev, pager, next, total, sizes, slot'
            },
        },
        data() {
            return {
                variable,
                loaded: false,
                activeName: "first",
                drawerCom: false,
                drawerRead: false,
                comList: [],
                readList: [],
                list:[],
                query: {},
                comment: '',
                atName:'',
                atId:'',

                // 表格尺寸
                size: help.store.get('tableSize') || variable.tableSize[0].key,
                hasLine: !!help.store.get('tableLine'),

                // 普通筛选
                normalSearchField: {},
                normalSearchValue: '',

                // 列设置
                columnSet: {
                    show: false,
                },

                // 高级查询
                advanceSearch: {
                    show: false,
                    list: [],
                    operateList: [
                        {key: 'eq', value: '等于'},
                        {key: 'ne', value: '不等于'},
                        {key: 'gt', value: '大于'},
                        {key: 'ge', value: '大于等于'},
                        {key: 'lt', value: '小于'},
                        {key: 'le', value: '小于等于'},
                        {key: 'like', value: '包含'},
                        {key: 'in', value: '属于'},
                        {key: 'notIn', value: '不属于'},
                    ],
                },

                commentDialog: {
                    show: false,
                    parentId: '',
                },
            }
        },
        created() {
            this.getList();
            // 赋值普通筛选
            for (let i = 0; i < this.cols.length; i += 1) {
                if (this.cols[i].searchNormal) {
                    this.normalSearchField = this.cols[i];
                    this.normalSearchChange();
                    return
                }
            }
        },
        computed: {
            // 普通筛选的列表
            normalSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchNormal)
                    )
                }
                return []
            },
            // 高级筛选的列表
            advanceSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchAdvance)
                    )
                }
                return []
            },
        },
        mounted() {
            this.loaded = true
        },
        methods: {
            triggerComm(row) {
                this.atName = row['userName'];
                this.atId = row['id'];
            },
            triggerDel(row) {

                this.$store.commit('confirm', {
                    content: '确定删除吗',
                    callback:(next, back) => {
                        // delKey
                        const param = {
                            id: row.id,
                        }

                        this.$api.post(this.comApi.del, param)
                        .then(res => {
                            next();
                            this.clearModel();
                            this.$emit('init');
                            this.$help.success(res.msg);
                        })
                        .finally(back)
                    },
                })

            },
            saveComment(){
                var pararm  = {};
                // 哪条头条信息
                if (this.headId) {
                    pararm.headId = this.headId
                }
                // insert
                if(this.atId) {
                    pararm.atId = this.atId;
                }
                pararm.comment = this.comment;

                // 新增评论内容
                this.$api.post(this.comApi.add, pararm)
                    .then(res => {
                        this.$help.success(res.msg);
                    })
                    .finally(() => {
                        this.$emit('init');
                    })
                this.clearModel();

            },
            clearModel() {
                this.comment = '';
                this.atName = '';
                this.atId = '';
            },
            getList() {
                if (this.cols && this.cols.length > 0) {
                    let list = help.deepClone(this.cols);

                    // 从localstorage里获取相关配置
                    const custom = help.store.get(`config_${this.name}`) || {};
                    list.map(item => {
                        if (custom[item.key]) {
                            item.viewSelf = !!custom[item.key].viewSelf;
                        } else {
                            item.viewSelf = true
                        }
                        return item;
                    })

                    list = list.sort((a, b) => {
                        return a.viewSort - b.viewSort;
                    });

                    this.list = list;
                } else {
                    this.list = []
                }
            },
            saveListCustom() {
                const param = {};
                this.list.forEach((item, index) => {
                    const obj = {};
                    obj.viewSort = index + 1;
                    obj.viewSelf = item.viewSelf ? 1 : 0;
                    param[item.key] = obj
                })
                help.store.set(`config_${this.name}`, JSON.stringify(param));
            },
            // 表格尺寸修改
            tableSizeChange(command) {
                if (command) {
                    this.size = command;
                    help.store.set('tableSize', this.size);
                }
            },
            tableLineChange() {
                help.store.set('tableLine', this.hasLine ? 1 : 0);
            },

            getCheckedRows() {
                return this.$refs.commTable.selection;
            },

            // 批量操作
            batchCommand(command) {
                const list = this.getCheckedRows();
                if (list.length > 0) {
                    if (command.api) {
                        this.$store.commit('confirm', {
                            title: '提示',
                            content: `确定${command.txt}`,
                            callback: (next, back) => {
                                const key = command.key || 'id'
                                this.$api.post(command.api, list.map(item => {
                                    const param = {}
                                    param[key] = item[key]
                                    return param
                                }))
                                    .then(res => {
                                        this.$help.success(res.errorTotalMsg)
                                        this.$emit('refresh')
                                        next()
                                    })
                                    .finally(back)
                            }
                        })
                    } else {
                        command && command.event(list)
                    }
                } else {
                    this.$help.error('请至少选择一行数据')
                }
            },

            // 普通筛选
            normalSearchChange() {
                this.normalSearchValue = '';
                // if (this.normalSearchField.type === 'das') {
                //     console.log('预留代码');
                // } else {
                //
                // }
            },
            normalSearchSave() {
                setTimeout(() => {
                    const param = {};
                    switch (this.normalSearchField.type) {
                        case variable.colType.DATE:
                            param[`${this.normalSearchField.key}Start`] = this.normalSearchValue[0]
                            param[`${this.normalSearchField.key}End`] = this.normalSearchValue[1]
                            break
                        case variable.colType.SELECT:
                            param[this.normalSearchField.key] = `${this.normalSearchValue}`
                            break
                        default:
                            param[`${this.normalSearchField.key}Like`] = this.normalSearchValue
                    }

                    this.$emit('paramChange', param);
                }, 0)
            },

            // 列设置
            columnSetShow() {
                this.columnSet.show = true;
            },

            // 高级筛选
            advanceSearchShow() {
                if(this.advanceSearch.list.length === 0) {
                    this.advanceSearch.list.push({});
                }
                this.advanceSearch.show = true;
            },
            advanceSearchCancel() {
                this.advanceSearch.list = [{}]
            },
            advanceSearchSave() {
                const param = [];
                this.advanceSearch.list.forEach(item => {
                    if (item.field && item.model && item.operate) {
                        param.push({
                            advancedFieldName: item.field.key,
                            advancedFieldValue: item.model,
                            advancedFieldOperator: item.operate
                        })
                    }
                })

                this.$emit('cndClusterChange', param)
                this.advanceSearch.show = false;
            },


            handleRowDbClickChange(row) {
                this.$emit('handleRowDbClickChange', row)
            },

            handleRowClickChange(row) {
                this.$refs.commTable.toggleRowSelection(row)
                this.$emit('handleRowClickChange', row)
            },
            sort(row) {
                this.$emit('sort', row)
            },

            // region 分页等操作
            handleSizeChange(val) {
                this.$emit('pageChange', {
                    size: val,
                    current: 1
                })
            },
            handleCurrentChange(val) {
                this.$emit('pageChange', {
                    current: val
                })
            },
            handleSelect(selection, row) {
                this.$emit('handleSelect', selection, row)
            },
            // endregion


        }
    }
</script>
